import PropTypes from 'prop-types';
import React from 'react';
import DraftRenderer from '../DraftRenderer/DraftRenderer';
import HotelDetailFeatures from './HotelDetailFeatures';
import HotelDetailPhotos from './HotelDetailPhotos';
import HotelContacts from './HotelContacts';
import DistanceTo from './DistanceTo';

class HotelDetail extends React.Component {
  render() {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 1,
    });

    const { hotel } = this.props;
    const taxRate = formatter.format(hotel.tax_rate);
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h1>{hotel.name}</h1>
            {hotel.brand && <h3>{hotel.brand.name}</h3>}
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <div className="hotel-distance">
              <p>
                {hotel.stars ? hotel.stars : '?'}
                <i className="fa fa-star" />
                <a
                  href={hotel.website}
                  title={hotel.website}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ marginLeft: 8 }}
                >
                  <span className={hotel.website ? 'fa fa-external-link' : 'hidden'} />
                </a>
              </p>
            </div>
            <p>
              <i className="fa fa-map-marker" />
              {hotel.address}, {hotel.locality}, {hotel.region} {hotel.postcode}
            </p>
            <DistanceTo {...this.props.distanceTo} />
            <p>
              <i className="fa fa-phone" style={{ marginRight: 8 }} />
              {hotel.tel}
            </p>
          </div>
          <div className="col-md-4">
            <HotelContacts hotel={hotel} />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-12 hotel-details-description">
            <h4 className="hotel-highlight">Property Description</h4>
            <DraftRenderer raw={hotel.description} placeholder="No property description." />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4 className="hotel-highlight">Details</h4>
          </div>
          <div className="col-md-4">
            <p>AAA Rating: {hotel.stars}</p>
            <p>Check-in Time: {hotel.check_in}</p>
            <p>Check-out Time: {hotel.check_out}</p>
            <p>Number of Rooms: {hotel.room_count}</p>
            <p>Number of Floors: {hotel.floors}</p>
          </div>
          <div className="col-md-4">
            <p>Currency: {hotel.currency}</p>
            <p>Tax Rate: {taxRate}</p>
            <p>Resort Fee: {hotel.resort_fee}</p>
          </div>
          <div className="col-md-12">
            <h4 className="hotel-highlight">Bus Parking</h4>
          </div>
          <div className="col-md-12">
            <p>Capacity: {hotel.bus_capacity}</p>
            <p>Notes: {hotel.bus_parking}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4 className="hotel-detail-subhead">Photos</h4>
          </div>
        </div>
        <div className="row">
          <HotelDetailPhotos photos={hotel.photos} />
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4 className="hotel-detail-subhead">Amenities</h4>
            <div className="row">
              <HotelDetailFeatures features={this.props.hotel.features} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HotelDetail.propTypes = {
  hotel: PropTypes.object.isRequired,
  distanceTo: PropTypes.object,
};
HotelDetail.defaultProps = {
  distanceTo: null,
};

export default HotelDetail;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelDetail.js